module.exports = __webpack_public_path__ + "app/components/login/user-confirmation.view.html";